
















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },
    data: function() {
        return {
            pathInStore: "property.location.surroundings.type",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL","APARTMENT", "LAND", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        propertySetting: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("fitted_out"),
                    "value": "FITTED_OUT"
                },
                {
                    "label": this.$t("concrete"),
                    "value": "CONCRETE"
                },
                {
                    "label": this.$t("mall"),
                    "value": "MALL"
                },
                {
                    "label": this.$t("compartmentalized"),
                    "value": "COMPARTMENTALIZED"
                },
                {
                    "label": this.$t("countryside"),
                    "value": "COUNTRY"
                },
                {
                    "label": this.$t("isolated"),
                    "value": "ISOLATED"
                },
                {
                    "label": this.$t("not_fitted_out"),
                    "value": "NOT_FITTED_OUT"
                },
                {
                    "label": this.$t("landscape"),
                    "value": "LANDSCAPE"
                },
                {
                    "label": this.$t("shop_street"),
                    "value": "SHOP_STREET"
                },
                {
                    "label": this.$t("residential"),
                    "value": "RESIDENTIAL"
                },
                {
                    "label": this.$t("urban"),
                    "value": "URBAN"
                }
            ];
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(propertySettingValue: string): void {
            if(propertySettingValue === "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": propertySettingValue});
            }
        }
    },
});
